import React from 'react'
import HowItWorksComponent from '../components/HowItWorksComponent'
import FeesComponent from '../components/FeesComponent'
import FAQs from '../components/FAQs'

const HowItWorks = () => {
  return (
    <div>
        <HowItWorksComponent/>
        <FeesComponent/>
        <FAQs/>
    </div>
  )
}

export default HowItWorks